export const selectOptionsEstimatedFico = [
  "Below 600",
  "600-620",
  "620-650",
  "650-680",
  "680-700",
  "700-720",
  "Greater than 720",
  "N/A do not have FICO",
];
